import { HomeTile } from '../../../_models/home-tile';
import { SHOP_URL_FALLBACK } from '../shop-config/shop-url';

/** navName kafelka zamawiania — po nim komponenty podmieniaja adres sklepu z bazy. */
export const ORDER_TILE_NAV_NAME = 'menu.orderSushi';

/**
 * Kafelki strony glownej i hamburgera (wersja PC) — JEDNO zrodlo kolejnosci.
 *
 * Kolejnosc jest decyzja redakcyjna i liczy sie liniowo: siatka sama lamie ja
 * na rzedy (`main-col-4` = 3 w rzedzie na PC, `main-col-xs-6` = 2 na telefonie),
 * wiec ta jedna lista daje oba uklady:
 *   PC:      Rezerwacje, Menu, Zamow do domu / Promocje, Restauracja, Kontakt
 *   telefon: Rezerwacje, Menu / Zamow do domu, Promocje / Restauracja, Kontakt
 *
 * Funkcja, a nie stala tablica: kazdy komponent dostaje wlasne obiekty, bo
 * podmienia w nich `link` kafelka zamawiania.
 */
export function createHomeTiles(): HomeTile[] {
  return [
    { buttonImageSrc: 'rezerwacja.svg', navName: 'menu.reservations', routerLink: ['/rezerwacje'], imageAlt: 'menu.reservationsAlt', link: '' },
    { buttonImageSrc: 'menu.svg', navName: 'menu.menuPl', routerLink: ['/menu'], imageAlt: 'menu.menuAlt', link: '' },
    // Wartosc poczatkowa = adres awaryjny, wiec kafelek ma poprawny `href` takze
    // w renderze, w ktorym API nie odpowie. Nadpisywana adresem z bazy.
    { buttonImageSrc: 'nawynos.svg', navName: ORDER_TILE_NAV_NAME, routerLink: '', imageAlt: 'menu.orderSushiAlt', link: SHOP_URL_FALLBACK },
    { buttonImageSrc: 'promo.svg', navName: 'menu.promotions', routerLink: ['/promocje'], imageAlt: 'menu.promotionsAlt', link: '' },
    { buttonImageSrc: 'restauracja.svg', navName: 'menu.restaurant', routerLink: ['/restauracja'], imageAlt: 'menu.restaurantAlt', link: '' },
    { buttonImageSrc: 'kontakt.svg', navName: 'menu.contact', routerLink: ['/kontakt'], imageAlt: 'menu.contactAlt', link: '' },
  ];
}

/** Podmienia adres kafelka zamawiania; reszta kafelkow bez zmian. */
export function withOrderLink(tiles: HomeTile[], href: string): HomeTile[] {
  return tiles.map((tile) => (tile.navName === ORDER_TILE_NAV_NAME ? { ...tile, link: href } : tile));
}
